module.exports = __webpack_public_path__ + "img/parkour_2.f7045121.jpg";